import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Imprint: React.FC = () => {
  return (
    <LegalLayout title="Imprint (Impressum)">
      <h2>Information according to § 5 DDG</h2>
      <p>
        Spiegelei Studio (Inh. Bing Xia)
        <br />
        Hedwig-Wachenheim-Karree 142
        <br />
        51107 Cologne
        <br />
        Germany
      </p>

      <h2>Contact</h2>
      <p>
        Email: <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a>
      </p>

      <h2>Payments</h2>
      <p>
        Purchases on the websites of our apps are processed by our online reseller Paddle.com,
        the Merchant of Record for all purchases on our websites. For questions about a payment, an invoice,
        or a refund, you can contact us or Paddle directly via{' '}
        <a href="https://paddle.net" target="_blank" rel="noopener noreferrer">paddle.net</a>.
      </p>

      <h2>Terms and privacy</h2>
      <p>
        Each app has its own terms of use, privacy policy, and refund policy, linked from the app
        on our <a href="/#billing">Pricing &amp; Billing</a> section.
      </p>
    </LegalLayout>
  );
};

export default Imprint;
